import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { LogOut } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dashHref = (user?.role === "admin" || user?.role === "senior_admin") ? "/admin" : user?.role === "landlord" ? "/landlord" : "/tenant";

  return (
    <nav className="sticky top-0 z-50 bg-navy text-white border-b border-white/10">
      <div className="max-w-7xl mx-auto px-3 sm:px-5 h-[68px] flex items-center justify-between gap-2">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 shrink-0">
          <Logo className="w-6 h-6 sm:w-7 sm:h-7 text-mint" />
          <span className="font-heading font-extrabold text-xl sm:text-2xl tracking-tight text-mint">Tenverly</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" data-testid="nav-search" className="text-sm font-medium text-slate-200 hover:text-mint transition-colors">Search</Link>
          <Link to="/how-it-works" data-testid="nav-how" className="text-sm font-medium text-slate-200 hover:text-mint transition-colors">How it Works</Link>
          <Link to="/renting-tips" data-testid="nav-tips" className="text-sm font-medium text-slate-200 hover:text-mint transition-colors">Renting Tips</Link>
          <Link to="/contact" data-testid="nav-about" className="text-sm font-medium text-slate-200 hover:text-mint transition-colors">Contact</Link>
        </div>

        <div className="flex items-center gap-1.5 sm:gap-3 shrink-0">
          {user ? (
            <>
              <Link to={dashHref} data-testid="nav-dashboard"
                className="text-sm font-semibold text-white border border-white/25 px-2.5 sm:px-3.5 py-2 rounded-lg hover:bg-white/10 transition-colors">Dashboard</Link>
              <Link to="/write-review" data-testid="nav-write-review"
                className="text-center whitespace-nowrap text-sm font-semibold bg-mint text-navy px-3 sm:px-4 py-2 rounded-lg hover:bg-mint-light transition-colors">
                <span className="sm:hidden">Review</span><span className="hidden sm:inline">Leave a Review</span>
              </Link>
              <button data-testid="nav-logout" aria-label="Log out" title="Log out" onClick={() => { logout(); navigate("/"); }}
                className="flex items-center justify-center w-9 h-9 rounded-lg text-slate-300 hover:text-white hover:bg-white/10 transition-colors shrink-0">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/write-review" data-testid="nav-write-review"
                className="text-center whitespace-nowrap text-sm font-semibold bg-mint text-navy px-3 sm:px-4 py-2 rounded-lg hover:bg-mint-light transition-colors">
                <span className="sm:hidden">Review</span><span className="hidden sm:inline">Leave a Review</span>
              </Link>
              <Link to="/login" data-testid="nav-login"
                className="text-sm font-semibold border border-white/30 text-white px-3 sm:px-4 py-2 rounded-lg hover:bg-white/10 transition-colors">
                Sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};
